export const REMOVE_APP_ERROR = 'removeAppError';

export const removeAppError = (errorType: string) => ({
    type: REMOVE_APP_ERROR,
    payload: errorType,
});
